export var ReportHeadingEnum;
(function (ReportHeadingEnum) {
    ReportHeadingEnum["Report"] = "Report";
})(ReportHeadingEnum || (ReportHeadingEnum = {}));
export class ReportHeadingConstants {
    static Report = "Report";
}
export const ReportHeadingMap = new Map([
    [ReportHeadingConstants.Report, ReportHeadingEnum.Report],
]);
